
import React, { useEffect, useRef, useState } from 'react';
import Modal from 'react-responsive-modal';
import metaDataServices from '../MetaData/MetaDataServices';

export function RegionTerritories(RegionTerritories: any) {

    console.log(RegionTerritories);
    let [territoryCode, setTerritoryCode] = useState<any>([]);
    let [Region_Selection, setRegion_Selection] = useState<any>([]);
    let [territorySelected, setTerritorySelected] = useState<any>([]);
    let [territoryIncluded, setTerritoryIncluded] = useState<any>([]);
    let [territoryRegionList, setTerritoryRegionList] = useState<any>([]);
    let [RegionList_Selection, setRegionList_Selection] = useState<any>([]);
    let [filterCombinedTerritory, setfilterCombinedTerritory] = useState("");

    const closeRegionTerritories = () => { RegionTerritories.closeRegionTerritories(); }

    useEffect(() => {

        metaDataServices.territoryRegionList().then((value: any) => {
            setTerritoryRegionList(value)
            console.log(value)

            for (var i = 0; i < value?.length; i++) {

                for (var y = 0; y < RegionTerritories?.data?.regionList?.length; y++) {

                    if (value[i].regionCode === RegionTerritories.data.regionList[y]) {
                        territorySelected.push(value[i])
                        setTerritorySelected(territorySelected);
                    }
                }
            }
        })

        if (RegionTerritories?.data?.regionList) {
            RegionList_Selection = RegionTerritories?.data?.regionList;
            setRegionList_Selection(RegionList_Selection)
        }
        Region_Selection = RegionTerritories?.data
        setRegion_Selection(Region_Selection)
        selectedRegion();

    }, []);

    const selectedRegion = () => {

        console.log(RegionList_Selection);

        if (RegionList_Selection) {
            var payload = { systemRegion: RegionList_Selection }
            console.log(payload)
            metaDataServices.territoryCode(payload).then((value: any) => {
                setTerritoryCode(value)
            })
        }

    }

    const RegionSelected = (regionCode: any) => {
        var foundSts = false;

        const find_array = RegionList_Selection.findIndex((value: any) => value == regionCode?.regionCode)

        if (find_array !== -1) {
            foundSts = true;
        }

        return foundSts;
    }

    const loadMasterRegionCheckbox = (regionCode: any) => {

        const find_array = RegionList_Selection.findIndex((value: any) => value == regionCode?.regionCode)
        if (find_array !== -1) {
            const updatedArray = [...RegionList_Selection];
            updatedArray.splice(find_array, 1);
            console.log(RegionList_Selection)
            RegionList_Selection = updatedArray
            setRegionList_Selection(updatedArray);
        } else {
            const updated_Array = [...RegionList_Selection];
            updated_Array.push(regionCode?.regionCode)
            RegionList_Selection = updated_Array
            setRegionList_Selection(updated_Array);
        }

        setRegionList_Selection(RegionList_Selection)
        console.log(find_array)
        console.log(RegionList_Selection)
        selectedRegion();
    }

    const loadregionItemCheckbox = (regionCode: any) => {
        console.log(regionCode)

        const find_array = territoryIncluded.findIndex((value: any) => value == territoryCode?.territoryCode)
        if (find_array !== -1) {
            const updatedArray = [...territoryIncluded];
            updatedArray.splice(find_array, 1);
            territoryIncluded = updatedArray
            setTerritoryIncluded(territoryIncluded);
        } else {
            const updated_Array = [...territoryIncluded];
            updated_Array.push(regionCode)
            territoryIncluded = updated_Array
            setTerritoryIncluded(territoryIncluded);
        }

        console.log(find_array)
        console.log(territoryIncluded)/**/
        setTerritoryIncluded(territoryIncluded);

        //selectedRegion();
    }

    const removeIncludeTeritory = (regionIndex: any) => {
        console.log(regionIndex)

        setTerritoryIncluded((prevItems: any) => prevItems.filter((data: any, i: any) => i !== regionIndex));
    }

    const RegionIncluded = (regionCode: any) => {

        var region_included = false
        const find_array = territoryIncluded.findIndex((value: any) => value == regionCode?.regionCode)
        if (find_array !== -1) {
            region_included = true;
        }

        return region_included;
    }

    const AvailableTerritories = () => {

        var Available_Territories: any = []


        if (territoryIncluded.length > 0) {

            const filteredArray = territoryCode.filter(
                (item1: any) => !territoryIncluded.some((item2: any) => item2.territoryCode === item1.territoryCode)
            );

            console.log(filteredArray)
        } else {
            Available_Territories = territoryCode
        }

        return Available_Territories;
    }

    const saveRegionCheckbox = () => {

        var save_region = {
            region: RegionList_Selection,
            territory: territoryIncluded
        }

        console.log(save_region)
        RegionTerritories.selectRegion(save_region)
    }

    const includeAllTerritory = () => {
        console.log(territoryCode)
        console.log(territoryIncluded)
        for (var i = 0; i < territoryCode?.length; i++) {
            loadregionItemCheckbox(territoryCode[i])
        }
    }

    const excludeAllTerritory = () => {
        console.log(territoryCode)
        console.log(territoryIncluded)
        for (var i = 0; i < territoryIncluded?.length; i++) {
            removeIncludeTeritory(i)
        }
        console.log(territoryCode)
        console.log(territoryIncluded)
    }

    return (

        <Modal open={RegionTerritories.openRegionTerritories} onClose={() => closeRegionTerritories()} styles={{ modalContainer: { background: 'transparent !important', width: "50% !important" } }} center classNames={{ overlay: '', modal: 'ws-6 paddingCenterBox bgTransparent' }} >
            <div className="box">

                <div className="box-header-main"><h2> <i className="fa fa-refresh"></i> Region Selection</h2></div>

                <div className="landing ws-12">

                    <div className="ws-3 pm box">
                        <span className="full-width text-bold text-m">System Regions</span>
                        {territoryRegionList.map((values: any) => {
                            return (
                                <>{(values.type === 'SYS') && <div className="pull-left full-width">
                                    <label className="pull-left">
                                        <input type="checkbox" checked={RegionSelected(values)} onChange={() => loadMasterRegionCheckbox(values)} />
                                        {values.regionName}

                                    </label>
                                </div>}</>
                            )
                        })}
                    </div>

                    <div className="w-73 m0">
                        {<div className="ws-7 m0 hide">
                            <h3 className="full-width pull-left mtl">
                                Custom Regions
                                <button type="button" className="btn btn-xs icon-btn edit" ng-click="regionItemCheckbox = []; createCustomRegion()">
                                    Create
                                </button>
                            </h3>

                            {(territoryRegionList.length > 0) && <div className="alert alert-info mt"> No Custom Region Available </div>}

                            {territoryRegionList.map((values: any) => {
                                return (
                                    <>{(values.type === 'CUS') && <div className="pull-left full-width">
                                        <label className="pull-left">
                                            <input type="checkbox" checked={RegionSelected(values.regionCode)} onChange={() => loadMasterRegionCheckbox(values.regionCode)} />
                                            {values.regionName}

                                        </label>
                                    </div>}</>
                                )
                            })}
                        </div>}

                        {/* Selected Territories */}
                        {<div className="ws-12 pm box mm">

                            <span className="full-width text-bold">Selected Territories</span>

                            <div className="ws-12 pbl pt">
                                <button type="button" className="icon-btn warning ps height35"> <i className="fa fa-filter"></i> Filter </button>
                                <button type="button" className="icon-btn edit ps height35"> <i className="fa fa-eraser"></i> Clear  </button>
                                <input type="text" className="ws-6 height35" placeholder="Search Region" value={filterCombinedTerritory} onChange={(e: any) => setfilterCombinedTerritory(e.target.value)} id="regions" />
                            </div>

                            {(territoryCode?.length === 0) && <div className="alert alert-info mt">No Territories matches your search criteria</div>}

                            <ul className="nav nav-list unstyled pull-left full-width mbl m0 p0">
                                {territoryCode?.filter((val: any) =>
                                    val?.territoryCode?.toLocaleLowerCase().includes(filterCombinedTerritory?.toLocaleLowerCase()) ||
                                    val?.territoryName?.toLocaleLowerCase().includes(filterCombinedTerritory?.toLocaleLowerCase())
                                ).map((values: any) => {
                                    return (
                                        <li className="ws-2 ps" >
                                            <input type="checkbox" onChange={() => loadregionItemCheckbox(values)} checked={RegionIncluded(values)} />
                                            {values.territoryCode}
                                        </li>
                                    )
                                })}

                            </ul>
                        </div>}

                        {/* Included Territories*/}
                        {<div className="ws-12 pm box mm">

                            <div className="ws-12">
                                <span className="text-bold ws-4 pull-left mt">Included Territories</span>

                                <button type="button" className="icon-btn delete pull-left" onClick={() => excludeAllTerritory()}> Un-Select All </button>
                            </div>

                            {(territoryIncluded.length === 0) && <div className="alert alert-info mt">No Territory has been selected yet</div>}

                            <ul className="nav nav-list unstyled pull-left full-width m0 mbl p0">
                                {territoryIncluded?.map((value: any, index: any) => {
                                    return (
                                        <li className="ws-2 m0">
                                            <input type="checkbox" checked onClick={() => removeIncludeTeritory(index)} />  {value.territoryCode}
                                        </li>
                                    )
                                })}
                            </ul>

                        </div>}

                        {/* Available Territories */}
                        {<div className="ws-12 pm box mm">

                            <div className="ws-12">
                                <span className="text-bold ws-4 pull-left mt">Available Territories</span>
                                <button type="button" className="icon-btn delete pull-left" onClick={() => includeAllTerritory()}> Select All </button>
                            </div>

                            {AvailableTerritories()?.lenght == 0 && <div className="alert alert-info mt" >All Territories have been selected  </div>}

                            <ul className="nav nav-list unstyled pull-left full-width mbl m0 p0">
                                {AvailableTerritories()?.map((values: any) => {
                                    return (
                                        <li className="ws-2 ps" >
                                            <input type="checkbox" onChange={() => loadregionItemCheckbox(values)} checked={RegionIncluded(values)} />
                                            {values.territoryCode}
                                        </li>
                                    )
                                })}

                            </ul>
                        </div>}
                    </div>

                </div>

                <div className="box-footer">
                    <button className="icon-btn delete width100 hight35" onClick={closeRegionTerritories}><i className="fa fa-close"></i> Close</button>
                    <button className="icon-btn edit width100 hight35 pull-right" onClick={saveRegionCheckbox}>
                        <i className="fa fa-save"></i> OK
                    </button>
                </div>
            </div>
        </Modal>
    )
}